import React from 'react';

import { getIsBoatManufacturer, getIsTrailerManufacturer, getIsComponentManufacturer } from 'helpers';

export default ({
  handleSortClick,
  order,
  sortedBy,
  isOilDashboard,
  tableColumnsWidths,
  isWithPaymentStatus,
  isWithCertificationStatus,
  user,
}) => {
  const isCompleteColumnShown =
    getIsBoatManufacturer(user) || getIsTrailerManufacturer(user) || getIsComponentManufacturer(user);

  function createClasses(id) {
    if (sortedBy === id) return `${order ? 'asc' : 'desc'} active`;
    return '';
  }

  return (
    <div className='list-scene__table-header'>
      <div
        className={`list-scene__table-header-element ${createClasses('code')} ${tableColumnsWidths['code']}`}
        onClick={handleSortClick('code')}
      >
        <div>ID</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element list-scene__table-row-element_place_filler
      ${createClasses('name')}`}
        onClick={handleSortClick('name')}
      >
        <div>Manufacturer Name</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      {isOilDashboard && (
        <div
          className={`list-scene__table-header-element ${createClasses('allRoles')} ${tableColumnsWidths['allRoles']}`}
          onClick={handleSortClick('allRoles')}
        >
          <div>Manufacturer Type</div>
          <div className='list-scene__table-header-element-sort-arrow' />
        </div>
      )}

      {isWithCertificationStatus && (
        <div
          className={`list-scene__table-header-element ${createClasses('isCertified')} ${
            tableColumnsWidths['isCertified']
          }`}
          onClick={handleSortClick('isCertified')}
        >
          <div>Certification</div>
          <div className='list-scene__table-header-element-sort-arrow' />
        </div>
      )}

      {!user.isInspector() && (
        <div
          className={`list-scene__table-header-element ${createClasses('active')} ${tableColumnsWidths['active']}`}
          onClick={handleSortClick('active')}
        >
          <div>Status</div>
          <div className='list-scene__table-header-element-sort-arrow' />
        </div>
      )}

      {isWithPaymentStatus && (
        <div
          className={`list-scene__table-header-element ${createClasses('isPaid')} ${tableColumnsWidths['isPaid']}`}
          onClick={handleSortClick('isPaid')}
        >
          <div>Payment</div>
          <div className='list-scene__table-header-element-sort-arrow' />
        </div>
      )}

      {isCompleteColumnShown && (
        <div
          className={`list-scene__table-header-element ${createClasses('isComplete')} ${tableColumnsWidths['isComplete']}`}
        >
          <div>Agreements</div>
          <div className='list-scene__table-header-element-sort-arrow' />
        </div>
      )}

      {user.isInternal() && (
        <div
          className={`list-scene__table-header-element ${createClasses('active')} ${tableColumnsWidths['actions']}`}
        />
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/DashboardScene/TableHeader.jsx